import React from "react"

import { useTranslation } from "@bounce/i18n"

import { PoiSlider } from "../../../../components/LuggageStorage/PoiSlider/PoiSlider"
import type { CityData } from "../../../../libs/bounce/cities"

export type EventsProps = {
  city: CityData
  className?: string
}

export const Places = ({ city, className }: EventsProps) => {
  const [t] = useTranslation("marketing-ls-event")

  if (!city.pois?.length) return null

  return (
    <PoiSlider
      pois={city.pois}
      limit={6}
      title={t("screen.event.otherPlaces", "Other places to explore in {{city}}", {
        city: city.translatedName,
      })}
      className={className}
    />
  )
}
